import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ShoppingBasket, MapPin, Grape, HandHeart, ArrowRight } from "lucide-react";

const steps = [
  {
    icon: ShoppingBasket,
    title: "Commandez en ligne",
    text: "En quelques clics, sans paiement en ligne.",
  },
  {
    icon: MapPin,
    title: "Retirez près de chez vous",
    text: "Choisissez le point le plus proche et réglez sur place.",
  },
  {
    icon: Grape,
    title: "Poussez la porte d'un domaine",
    text: "Un vigneron, un caveau : profitez du retrait pour le découvrir, ou le retrouver.",
  },
  {
    icon: HandHeart,
    title: "Restez fidèle à votre terroir",
    text: "Ce qui est bon, c'est souvent ce qui est proche de chez vous.",
  },
];

const ConceptCommande = () => {
  const navigate = useNavigate();
  return (
    <section id="concept" className="bg-sable py-20 sm:py-28" data-testid="concept-section">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl"
        >
          <span className="text-sm uppercase tracking-[0.3em] text-mousse font-500">Notre concept</span>
          <h2 className="font-heading text-3xl sm:text-4xl text-foreground mt-3 leading-tight">
            Commandez en ligne, retirez chez un vigneron près de chez vous
          </h2>
          <p className="text-foreground/70 mt-4 text-base leading-relaxed">
            Vous commandez en ligne, puis vous récupérez vos escargots chez un vigneron ou dans un
            caveau partenaire. Nous les avons choisis parce qu'ils partagent notre goût du terroir et
            du travail bien fait. Le jour du retrait, c'est l'occasion de pousser leur porte.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-12">
          {steps.map((s, i) => (
            <motion.div
              key={s.title}
              data-testid={`concept-step-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="relative bg-creme rounded-2xl border border-border p-6 hover:-translate-y-1 transition-transform"
            >
              <span className="absolute -top-3 left-6 w-7 h-7 rounded-full bg-bordeaux text-white text-sm font-700 flex items-center justify-center">
                {i + 1}
              </span>
              <span className="w-12 h-12 rounded-xl bg-bordeaux/10 text-bordeaux flex items-center justify-center mb-4">
                <s.icon size={24} />
              </span>
              <h3 className="font-600 text-foreground text-lg">{s.title}</h3>
              <p className="text-sm text-foreground/70 mt-2 leading-relaxed">{s.text}</p>
            </motion.div>
          ))}
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center gap-5">
          <button
            data-testid="concept-order-btn"
            onClick={() => navigate("/commander")}
            className="rounded-full bg-bordeaux text-white font-600 px-8 py-4 hover:bg-bordeaux-dark transition-all hover:-translate-y-0.5 inline-flex items-center gap-2 shadow-lg shadow-black/10"
          >
            <ShoppingBasket size={19} /> Commander pour Noël 2026 <ArrowRight size={17} />
          </button>
          <p className="text-sm text-foreground/60 max-w-sm">
            Paiement uniquement sur place, lors du retrait. Aucune donnée bancaire ne vous est demandée.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ConceptCommande;
